import React from "react";
import { useFormVendorConnectHook } from "./form-vendor-connect-hooks";

type ContextFormVendorConnect = ReturnType<typeof useFormVendorConnectHook>;

export const FormVendorConnectContext =
  React.createContext<ContextFormVendorConnect | null>(null);

export function useContextFormVendorConnect() {
  const context = React.useContext(FormVendorConnectContext);

  if (!context) {
    throw new Error(
      "useContextFormVendorConnect must be used within a ContextFormVendorConnectProvider",
    );
  }

  return context;
}
